import React, { useEffect, useState } from 'react'
import './index.scss'
import LogoLandtrust from '../../../../asset/Landtrust_logo_white.svg'
import ReusableButton from '../reusableComponents/button/customButton'
import { connect } from 'react-redux'
import LandTrustMainScreen from '../components/mainScreen'
import { fetchPrivateLandGetFilterValues } from '../../../action/private-lands-action'
import { landTrustRightMenuBarHide, landTrustRightMenuBarexpand, landTrustRightMenuBarClose, landTrustDetailsMenuBarHide } from '../../../action/land-trust-menu-bar'

const RecreationalAccess = (props) => {
  const [openHuntPlanner, setOpenHuntPlanner] = useState(false)

  useEffect(() => {
    // props.landTrustRightMenuBarHide()
    props.landTrustRightMenuBarexpand()
    props.landTrustRightMenuBarClose()
  }, [])

  let handleClick = () => {
    setOpenHuntPlanner(true)
    props.fetchPrivateLandGetFilterValues()
  }

  return (
    <div className='land-trust-landing-page-container'>

      <img className='land-trust-logo' src={LogoLandtrust}></img>
      <p className='land-trust-landing-page-description'>Get Outdoors Without the Crowds. Connect with landowners and book exclusive access on private land for your next outdoor adventure</p>
      {
        <ReusableButton
          className='lets-go-button lets-go-button-label'
          label="LETS GO "
          onClick={handleClick}
          variant="primary"
          size="small"
          buttonWidth='236px'
          buttonHeight="50px"
        />
      }
      {openHuntPlanner && <LandTrustMainScreen></LandTrustMainScreen>}
    </div>
  )
}

const mapStateToProps = state => ({
  selectedTabvalue: state.selectedTab,
  user: state.user,
})

const mapDispatchToProps = dispatch => ({
  fetchPrivateLandGetFilterValues: () => dispatch(fetchPrivateLandGetFilterValues()),
  landTrustRightMenuBarHide: () => dispatch(landTrustRightMenuBarHide()),
  landTrustRightMenuBarexpand: () => dispatch(landTrustRightMenuBarexpand()),
  landTrustRightMenuBarClose: () => dispatch(landTrustRightMenuBarClose())
})

export default connect(mapStateToProps, mapDispatchToProps)(RecreationalAccess)


